import { del, get, post, put } from './api.service';

const base_url = 'workers/v1';

export const getAll = (params: {
    page?: number,
    per_page?: number,
    search?: string,
    type?: string,
    status?: string,
    order?: string,
    table_id?: number | string,
    with_relationship?: string,
} = {}) => {
    const queryString = Object.keys(params)
        .filter(key => params[key as keyof typeof params])
        .map(key => {
            return `${key}=${params[key as keyof typeof params]}`;
        }).join('&');

    let url = queryString ? base_url + `?${queryString}` : base_url;

    return get(url);
}

export const getById = (id: number, params: {
    with_relationship?: string
} | undefined = undefined) => {
    const queryString = Object.keys(params || {})
        .filter(key => (params || {})[key as keyof typeof params])
        .map(key => {
            return `${key}=${(params || {})[key as keyof typeof params]}`;
        }).join('&');
 
    let url = queryString ? `${base_url}/${id}` + `?${queryString}` : `${base_url}/${id}`;
 
    return get(url);
}

export const create = (data: object) => {
    return post(base_url, data);
}

export const update = (data: { values: object, id: number }) => {
    return put(`${base_url}/${data.id}`, data.values);
}

export const remove = (id: number | undefined) => {
    return del(`${base_url}/${id}`);
}
